/** Генерируется автоматически с помощью EnvconfigPlugin */
import { createEnvVar } from '@alfa-bank/site-envconfig-utils/helpers';

export const ALFAFORM_PIL_FLOW_API = createEnvVar(
    'ALFAFORM_PIL_FLOW_API',
    process.env.ALFAFORM_PIL_FLOW_API
);
export const ANKETA_MAIN_HOST = createEnvVar('ANKETA_MAIN_HOST', process.env.ANKETA_MAIN_HOST);
export const ATM_MAP_API_URL = createEnvVar('ATM_MAP_API_URL', process.env.ATM_MAP_API_URL);
export const ATM_MAP_URL_FALLBACK = createEnvVar(
    'ATM_MAP_URL_FALLBACK',
    process.env.ATM_MAP_URL_FALLBACK
);
export const AUTH_ALFAID_INITIALIZE = createEnvVar(
    'AUTH_ALFAID_INITIALIZE',
    process.env.AUTH_ALFAID_INITIALIZE
);
export const AUTH_OTP_REQUEST = createEnvVar('AUTH_OTP_REQUEST', process.env.AUTH_OTP_REQUEST);
export const AUTH_OTP_VERIFY = createEnvVar('AUTH_OTP_VERIFY', process.env.AUTH_OTP_VERIFY);
export const AUTOCREDIT_APPOINTMENT_FORM_AVAILABLE_DATES = createEnvVar(
    'AUTOCREDIT_APPOINTMENT_FORM_AVAILABLE_DATES',
    process.env.AUTOCREDIT_APPOINTMENT_FORM_AVAILABLE_DATES
);
export const AUTOCREDIT_APPOINTMENT_FORM_CHECK_ADDRESS = createEnvVar(
    'AUTOCREDIT_APPOINTMENT_FORM_CHECK_ADDRESS',
    process.env.AUTOCREDIT_APPOINTMENT_FORM_CHECK_ADDRESS
);
export const AUTOCREDIT_APPOINTMENT_FORM_DELIVERY_AVAILABILITY = createEnvVar(
    'AUTOCREDIT_APPOINTMENT_FORM_DELIVERY_AVAILABILITY',
    process.env.AUTOCREDIT_APPOINTMENT_FORM_DELIVERY_AVAILABILITY
);
export const AUTOCREDIT_APPOINTMENT_FORM_SUGGEST_CITIES = createEnvVar(
    'AUTOCREDIT_APPOINTMENT_FORM_SUGGEST_CITIES',
    process.env.AUTOCREDIT_APPOINTMENT_FORM_SUGGEST_CITIES
);
export const BANANZA_PRIZES = createEnvVar('BANANZA_PRIZES', process.env.BANANZA_PRIZES);
export const BANDIT_URL = createEnvVar('BANDIT_URL', process.env.BANDIT_URL);
export const BASE_API_URL = createEnvVar('BASE_API_URL', process.env.BASE_API_URL);
export const BASE_API_URL_FOR_DEVELOPMENT = createEnvVar(
    'BASE_API_URL_FOR_DEVELOPMENT',
    process.env.BASE_API_URL_FOR_DEVELOPMENT
);
export const BIDDING_TENDERS = createEnvVar('BIDDING_TENDERS', process.env.BIDDING_TENDERS);
export const CITIES = createEnvVar('CITIES', process.env.CITIES);
export const CITIES_GROUP = createEnvVar('CITIES_GROUP', process.env.CITIES_GROUP);
export const CITIES_GROUP_URL = createEnvVar('CITIES_GROUP_URL', process.env.CITIES_GROUP_URL);
export const CITIES_GROUP_URL_V2 = createEnvVar(
    'CITIES_GROUP_URL_V2',
    process.env.CITIES_GROUP_URL_V2
);
export const CITIES_URL = createEnvVar('CITIES_URL', process.env.CITIES_URL);
export const CITIES_URL_V2 = createEnvVar('CITIES_URL_V2', process.env.CITIES_URL_V2);
export const CITY_BY_IP_URL = createEnvVar('CITY_BY_IP_URL', process.env.CITY_BY_IP_URL);
export const CITY_BY_IP_URL_V2 = createEnvVar('CITY_BY_IP_URL_V2', process.env.CITY_BY_IP_URL_V2);
export const COMMON_DRAFT_ARCHIVARIUS = createEnvVar(
    'COMMON_DRAFT_ARCHIVARIUS',
    process.env.COMMON_DRAFT_ARCHIVARIUS
);
export const CORE_INPUT_ENABLE = createEnvVar('CORE_INPUT_ENABLE', process.env.CORE_INPUT_ENABLE);
export const CPAS_DADATA_PROXY = createEnvVar('CPAS_DADATA_PROXY', process.env.CPAS_DADATA_PROXY);
export const CPAS_DELIVERY_OF_SERVICES = createEnvVar(
    'CPAS_DELIVERY_OF_SERVICES',
    process.env.CPAS_DELIVERY_OF_SERVICES
);
export type TCpasDeliveryOfServicesAvailableDatesParams = {
    dateFrom: string | number;
    dateTo: string | number;
    deliveryUuid: string | number;
};
export const CPAS_DELIVERY_OF_SERVICES_AVAILABLE_DATES =
    createEnvVar<TCpasDeliveryOfServicesAvailableDatesParams>(
        'CPAS_DELIVERY_OF_SERVICES_AVAILABLE_DATES',
        process.env.CPAS_DELIVERY_OF_SERVICES_AVAILABLE_DATES
    );
export type TCpasDeliveryOfServicesBookingSlotParams = {
    uuid: string | number;
};
export const CPAS_DELIVERY_OF_SERVICES_BOOKING_SLOT =
    createEnvVar<TCpasDeliveryOfServicesBookingSlotParams>(
        'CPAS_DELIVERY_OF_SERVICES_BOOKING_SLOT',
        process.env.CPAS_DELIVERY_OF_SERVICES_BOOKING_SLOT
    );
export const CPAS_DELIVERY_OF_SERVICES_CODE_REQUEST = createEnvVar(
    'CPAS_DELIVERY_OF_SERVICES_CODE_REQUEST',
    process.env.CPAS_DELIVERY_OF_SERVICES_CODE_REQUEST
);
export const CPAS_DELIVERY_OF_SERVICES_CODE_VERIFICATION = createEnvVar(
    'CPAS_DELIVERY_OF_SERVICES_CODE_VERIFICATION',
    process.env.CPAS_DELIVERY_OF_SERVICES_CODE_VERIFICATION
);
export type TCpasDeliveryOfServicesConfirmationDeliveryParams = {
    uuid: string | number;
};
export const CPAS_DELIVERY_OF_SERVICES_CONFIRMATION_DELIVERY =
    createEnvVar<TCpasDeliveryOfServicesConfirmationDeliveryParams>(
        'CPAS_DELIVERY_OF_SERVICES_CONFIRMATION_DELIVERY',
        process.env.CPAS_DELIVERY_OF_SERVICES_CONFIRMATION_DELIVERY
    );
export type TCpasDeliveryOfServicesDeliveryAvailabilityParams = {
    accuracy: string | number;
    address: string | number;
    latitude: string | number;
    longitude: string | number;
    region: string | number;
};
export const CPAS_DELIVERY_OF_SERVICES_DELIVERY_AVAILABILITY =
    createEnvVar<TCpasDeliveryOfServicesDeliveryAvailabilityParams>(
        'CPAS_DELIVERY_OF_SERVICES_DELIVERY_AVAILABILITY',
        process.env.CPAS_DELIVERY_OF_SERVICES_DELIVERY_AVAILABILITY
    );
export const CPAS_DELIVERY_OF_SERVICES_DRAFTS = createEnvVar(
    'CPAS_DELIVERY_OF_SERVICES_DRAFTS',
    process.env.CPAS_DELIVERY_OF_SERVICES_DRAFTS
);
export const CYCLOPEDIA_ALL_ENTITIES = createEnvVar(
    'CYCLOPEDIA_ALL_ENTITIES',
    process.env.CYCLOPEDIA_ALL_ENTITIES
);
export const DADATA_PROXY_CLEAN_ADDRESS = createEnvVar(
    'DADATA_PROXY_CLEAN_ADDRESS',
    process.env.DADATA_PROXY_CLEAN_ADDRESS
);
export const DADATA_PROXY_FIND_BY_PARTY = createEnvVar(
    'DADATA_PROXY_FIND_BY_PARTY',
    process.env.DADATA_PROXY_FIND_BY_PARTY
);
export const DADATA_PROXY_GEOLOCATE_ADDRESS = createEnvVar(
    'DADATA_PROXY_GEOLOCATE_ADDRESS',
    process.env.DADATA_PROXY_GEOLOCATE_ADDRESS
);
export const DADATA_PROXY_SUGGEST_ADDRESS = createEnvVar(
    'DADATA_PROXY_SUGGEST_ADDRESS',
    process.env.DADATA_PROXY_SUGGEST_ADDRESS
);
export const DADATA_PROXY_SUGGEST_FIO = createEnvVar(
    'DADATA_PROXY_SUGGEST_FIO',
    process.env.DADATA_PROXY_SUGGEST_FIO
);
export const DADATA_PROXY_SUGGEST_FMS_UNIT = createEnvVar(
    'DADATA_PROXY_SUGGEST_FMS_UNIT',
    process.env.DADATA_PROXY_SUGGEST_FMS_UNIT
);
export const DADATA_PROXY_SUGGEST_PARTY = createEnvVar(
    'DADATA_PROXY_SUGGEST_PARTY',
    process.env.DADATA_PROXY_SUGGEST_PARTY
);
export const DADATA_PROXY_URL = createEnvVar('DADATA_PROXY_URL', process.env.DADATA_PROXY_URL);
export const DADATA_SUGGEST_FIO = createEnvVar(
    'DADATA_SUGGEST_FIO',
    process.env.DADATA_SUGGEST_FIO
);
export const DADATA_SUGGEST_PARTY = createEnvVar(
    'DADATA_SUGGEST_PARTY',
    process.env.DADATA_SUGGEST_PARTY
);
export const DC_DRAFT = createEnvVar('DC_DRAFT', process.env.DC_DRAFT);
export const DC_DRAFT_FIRST_STEP = createEnvVar(
    'DC_DRAFT_FIRST_STEP',
    process.env.DC_DRAFT_FIRST_STEP
);
export const DC_FORM_ANKETA_PATH = createEnvVar(
    'DC_FORM_ANKETA_PATH',
    process.env.DC_FORM_ANKETA_PATH
);
export type TDcFormJustAiPathParams = {
    key: string | number;
};
export const DC_FORM_JUST_AI_PATH = createEnvVar<TDcFormJustAiPathParams>(
    'DC_FORM_JUST_AI_PATH',
    process.env.DC_FORM_JUST_AI_PATH
);
export const DC_FORM_SENDER_APPLICATIONS = createEnvVar(
    'DC_FORM_SENDER_APPLICATIONS',
    process.env.DC_FORM_SENDER_APPLICATIONS
);
export type TDcFormSenderApplicationsCashbackCategoriesParams = {
    groupType: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_CASHBACK_CATEGORIES =
    createEnvVar<TDcFormSenderApplicationsCashbackCategoriesParams>(
        'DC_FORM_SENDER_APPLICATIONS_CASHBACK_CATEGORIES',
        process.env.DC_FORM_SENDER_APPLICATIONS_CASHBACK_CATEGORIES
    );
export type TDcFormSenderApplicationsCodesDeliveryResendParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_RESEND =
    createEnvVar<TDcFormSenderApplicationsCodesDeliveryResendParams>(
        'DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_RESEND',
        process.env.DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_RESEND
    );
export type TDcFormSenderApplicationsCodesDeliveryVerifyParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_VERIFY =
    createEnvVar<TDcFormSenderApplicationsCodesDeliveryVerifyParams>(
        'DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_VERIFY',
        process.env.DC_FORM_SENDER_APPLICATIONS_CODES_DELIVERY_VERIFY
    );
export type TDcFormSenderApplicationsCodesResendParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_CODES_RESEND =
    createEnvVar<TDcFormSenderApplicationsCodesResendParams>(
        'DC_FORM_SENDER_APPLICATIONS_CODES_RESEND',
        process.env.DC_FORM_SENDER_APPLICATIONS_CODES_RESEND
    );
export type TDcFormSenderApplicationsCodesVerifyParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_CODES_VERIFY =
    createEnvVar<TDcFormSenderApplicationsCodesVerifyParams>(
        'DC_FORM_SENDER_APPLICATIONS_CODES_VERIFY',
        process.env.DC_FORM_SENDER_APPLICATIONS_CODES_VERIFY
    );
export type TDcFormSenderApplicationsDeliveriesSearchParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_DELIVERIES_SEARCH =
    createEnvVar<TDcFormSenderApplicationsDeliveriesSearchParams>(
        'DC_FORM_SENDER_APPLICATIONS_DELIVERIES_SEARCH',
        process.env.DC_FORM_SENDER_APPLICATIONS_DELIVERIES_SEARCH
    );
export type TDcFormSenderApplicationsDeliveriesTimeSlotsParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_DELIVERIES_TIME_SLOTS =
    createEnvVar<TDcFormSenderApplicationsDeliveriesTimeSlotsParams>(
        'DC_FORM_SENDER_APPLICATIONS_DELIVERIES_TIME_SLOTS',
        process.env.DC_FORM_SENDER_APPLICATIONS_DELIVERIES_TIME_SLOTS
    );
export type TDcFormSenderApplicationsDraftsCheckParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_DRAFTS_CHECK =
    createEnvVar<TDcFormSenderApplicationsDraftsCheckParams>(
        'DC_FORM_SENDER_APPLICATIONS_DRAFTS_CHECK',
        process.env.DC_FORM_SENDER_APPLICATIONS_DRAFTS_CHECK
    );
export type TDcFormSenderApplicationsFinishParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_FINISH =
    createEnvVar<TDcFormSenderApplicationsFinishParams>(
        'DC_FORM_SENDER_APPLICATIONS_FINISH',
        process.env.DC_FORM_SENDER_APPLICATIONS_FINISH
    );
export type TDcFormSenderApplicationsPassportParams = {
    appId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_PASSPORT =
    createEnvVar<TDcFormSenderApplicationsPassportParams>(
        'DC_FORM_SENDER_APPLICATIONS_PASSPORT',
        process.env.DC_FORM_SENDER_APPLICATIONS_PASSPORT
    );
export type TDcFormSenderApplicationsRestoreDraftParams = {
    draftId: string | number;
};
export const DC_FORM_SENDER_APPLICATIONS_RESTORE_DRAFT =
    createEnvVar<TDcFormSenderApplicationsRestoreDraftParams>(
        'DC_FORM_SENDER_APPLICATIONS_RESTORE_DRAFT',
        process.env.DC_FORM_SENDER_APPLICATIONS_RESTORE_DRAFT
    );
export const DEPOSITARY_NEWS_NEWS = createEnvVar(
    'DEPOSITARY_NEWS_NEWS',
    process.env.DEPOSITARY_NEWS_NEWS
);
export const DEPOSITARY_NEWS_PUBLICATION_DATES = createEnvVar(
    'DEPOSITARY_NEWS_PUBLICATION_DATES',
    process.env.DEPOSITARY_NEWS_PUBLICATION_DATES
);
export const EMAIL_FIELD = createEnvVar('EMAIL_FIELD', process.env.EMAIL_FIELD);
export const EXCHANGE_RATES_API_URL = createEnvVar(
    'EXCHANGE_RATES_API_URL',
    process.env.EXCHANGE_RATES_API_URL
);
export const FEEDBACK_FORM_HOST = createEnvVar(
    'FEEDBACK_FORM_HOST',
    process.env.FEEDBACK_FORM_HOST
);
export const FONT_PATH_URL = createEnvVar('FONT_PATH_URL', process.env.FONT_PATH_URL);
export const FORMS_CONSUMER_FORMS = createEnvVar(
    'FORMS_CONSUMER_FORMS',
    process.env.FORMS_CONSUMER_FORMS
);
export const GEO_CITIES_URL = createEnvVar('GEO_CITIES_URL', process.env.GEO_CITIES_URL);
export const GRAPHQL_API_URL = createEnvVar('GRAPHQL_API_URL', process.env.GRAPHQL_API_URL);
export const GRAPHQL_URL_FALLBACK = createEnvVar(
    'GRAPHQL_URL_FALLBACK',
    process.env.GRAPHQL_URL_FALLBACK
);
export const ISSUE_REPORTS_NEWS = createEnvVar(
    'ISSUE_REPORTS_NEWS',
    process.env.ISSUE_REPORTS_NEWS
);
export const MAGNETO_METALS = createEnvVar('MAGNETO_METALS', process.env.MAGNETO_METALS);
export const MAPS_DADATA_PROXY = createEnvVar('MAPS_DADATA_PROXY', process.env.MAPS_DADATA_PROXY);
export const MORTGAGE_API_HOST = createEnvVar('MORTGAGE_API_HOST', process.env.MORTGAGE_API_HOST);
export const MORTGAGE_FORM_HOST = createEnvVar(
    'MORTGAGE_FORM_HOST',
    process.env.MORTGAGE_FORM_HOST
);
export const MORTGAGE_FORM_REGIONS = createEnvVar(
    'MORTGAGE_FORM_REGIONS',
    process.env.MORTGAGE_FORM_REGIONS
);
export const OFFERS_CLIENT_URL = createEnvVar('OFFERS_CLIENT_URL', process.env.OFFERS_CLIENT_URL);
export const OFFERS_CODES_URL = createEnvVar('OFFERS_CODES_URL', process.env.OFFERS_CODES_URL);
export const OFFERS_URL = createEnvVar('OFFERS_URL', process.env.OFFERS_URL);
export const OFFICES_MAP_API_URL = createEnvVar(
    'OFFICES_MAP_API_URL',
    process.env.OFFICES_MAP_API_URL
);
export const OFFICES_MAP_URL_FALLBACK = createEnvVar(
    'OFFICES_MAP_URL_FALLBACK',
    process.env.OFFICES_MAP_URL_FALLBACK
);
export type TPressNewsItemParams = {
    path: string | number;
};
export const PRESS_NEWS_ITEM = createEnvVar<TPressNewsItemParams>(
    'PRESS_NEWS_ITEM',
    process.env.PRESS_NEWS_ITEM
);
export const PRESS_NEWS_LIST = createEnvVar('PRESS_NEWS_LIST', process.env.PRESS_NEWS_LIST);
export const PRESS_NEWS_PUBLICATION_TYPES = createEnvVar(
    'PRESS_NEWS_PUBLICATION_TYPES',
    process.env.PRESS_NEWS_PUBLICATION_TYPES
);
export const PRESS_NEWS_TAGS = createEnvVar('PRESS_NEWS_TAGS', process.env.PRESS_NEWS_TAGS);
export const PROMO_CARDS_ENDPOINT = createEnvVar(
    'PROMO_CARDS_ENDPOINT',
    process.env.PROMO_CARDS_ENDPOINT
);
export const RECAPTCHA_KEY = createEnvVar('RECAPTCHA_KEY', process.env.RECAPTCHA_KEY);
export const RECOGNITION_UTM_URL = createEnvVar(
    'RECOGNITION_UTM_URL',
    process.env.RECOGNITION_UTM_URL
);
export const ROUPER_PERSONALIZATION_URL = createEnvVar(
    'ROUPER_PERSONALIZATION_URL',
    process.env.ROUPER_PERSONALIZATION_URL
);
export type TSearchBlockUrlTemplateParams = {
    text: string | number;
};
export const SEARCH_BLOCK_URL_TEMPLATE = createEnvVar<TSearchBlockUrlTemplateParams>(
    'SEARCH_BLOCK_URL_TEMPLATE',
    process.env.SEARCH_BLOCK_URL_TEMPLATE
);
export const SHERLOCK_SITE_SEARCH = createEnvVar(
    'SHERLOCK_SITE_SEARCH',
    process.env.SHERLOCK_SITE_SEARCH
);
export const STORYBOOK_DADATA = createEnvVar('STORYBOOK_DADATA', process.env.STORYBOOK_DADATA);
export const TRANBILOG_URL = createEnvVar('TRANBILOG_URL', process.env.TRANBILOG_URL);
export type TVimeoIframeTemplateParams = {
    videoId: string | number;
};
export const VIMEO_IFRAME_TEMPLATE = createEnvVar<TVimeoIframeTemplateParams>(
    'VIMEO_IFRAME_TEMPLATE',
    process.env.VIMEO_IFRAME_TEMPLATE
);
export type TVimeoThumbnailTemplateParams = {
    videoId: string | number;
};
export const VIMEO_THUMBNAIL_TEMPLATE = createEnvVar<TVimeoThumbnailTemplateParams>(
    'VIMEO_THUMBNAIL_TEMPLATE',
    process.env.VIMEO_THUMBNAIL_TEMPLATE
);
export type TVkIframeTemplateParams = {
    apiParams: string | number;
    autoplay: string | number;
    hash: string | number;
    ownerId: string | number;
    videoId: string | number;
};
export const VK_IFRAME_TEMPLATE = createEnvVar<TVkIframeTemplateParams>(
    'VK_IFRAME_TEMPLATE',
    process.env.VK_IFRAME_TEMPLATE
);
export const WEB_DEV_KEY = createEnvVar('WEB_DEV_KEY', process.env.WEB_DEV_KEY);
export const YANDEX_METRIC_STATIC_URL = createEnvVar(
    'YANDEX_METRIC_STATIC_URL',
    process.env.YANDEX_METRIC_STATIC_URL
);
export const YANDEX_SEARCH_RESULTS_PAGE_URL = createEnvVar(
    'YANDEX_SEARCH_RESULTS_PAGE_URL',
    process.env.YANDEX_SEARCH_RESULTS_PAGE_URL
);
export const YANDEX_SEARCH_SUGGEST_API_URL = createEnvVar(
    'YANDEX_SEARCH_SUGGEST_API_URL',
    process.env.YANDEX_SEARCH_SUGGEST_API_URL
);
export type TYaMapParams = {
    apiKey: string | number;
};
export const YA_MAP = createEnvVar<TYaMapParams>('YA_MAP', process.env.YA_MAP);
export const YA_MAP_KEY = createEnvVar('YA_MAP_KEY', process.env.YA_MAP_KEY);
export const YA_MAP_SUGGEST_API_KEY = createEnvVar(
    'YA_MAP_SUGGEST_API_KEY',
    process.env.YA_MAP_SUGGEST_API_KEY
);
export type TYoutubeIframeTemplateParams = {
    apiParams: string | number;
    videoId: string | number;
};
export const YOUTUBE_IFRAME_TEMPLATE = createEnvVar<TYoutubeIframeTemplateParams>(
    'YOUTUBE_IFRAME_TEMPLATE',
    process.env.YOUTUBE_IFRAME_TEMPLATE
);
export type TYoutubeThumbnailTemplateParams = {
    videoId: string | number;
};
export const YOUTUBE_THUMBNAIL_TEMPLATE = createEnvVar<TYoutubeThumbnailTemplateParams>(
    'YOUTUBE_THUMBNAIL_TEMPLATE',
    process.env.YOUTUBE_THUMBNAIL_TEMPLATE
);
